var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"readable-weektime"},_vm._l((_vm.list),function(t){return _c('div',{key:t.id},[(t.value)?_c('p',[_c('span',{staticClass:"g-tip-text"},[_vm._v(_vm._s(t.week)+"：")]),_c('span',[_vm._v(_vm._s(t.value))])]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }